<template>
  <div>
    <solution-header
      :actIndex="actIndex"
      :imgList="headImgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    >
    </solution-header>
    <!-- <div v-html="solutionData"></div> -->
    <div class="fa_content">
      <h2>FA融资服务</h2>
      <div class="fa_service_box">
          <div v-for="(item,index) in faServiceList" :key="index" class="fa_service_list">
            <img :src="item.url" alt='图片' />
            <p>{{item.title}}</p>
            <p>{{item.intro}}</p>
          </div>
      </div>
      <h2>服务流程</h2>
      <div class="process_box">
          <div class="process-line"></div>
        <div>
          <div v-for="(item,index) in serviceList" :key="index" class="process_list">
            <div class="serial_num">{{index+1}}</div>
            <div class="peocess_right_box">
              <div class="">
                <h3>{{item.title}}</h3>
                <p>{{item.intro}}</p>
              </div>
              <img :src="item.url" alt='图片' />
            </div>
          </div>

        </div>
      </div>
      <h2>合作机构</h2>
      <div class="agency_box">
          <img :src="item.pc_image" alt='图片' v-for="(item,index) in imgList" :key="index" />
      </div>
    
    </div>
    <solution-footer
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :bottomNews="bottomNews"
      :productType="productType"
    ></solution-footer>
  </div>
</template>

<script>
import solutionHeader from "@/components/mobile/Header";
import solutionFooter from "@/components/mobile/Footer";
export default {
  name: "m_solution",
  data() {
    return {
      solutionData: "",
      solutionType: "",
      topStyle: "",
      actIndex: 2,
      headImgList:[],
      imgList: [],
      logo: "",
      productType: [],
      bottom: {},
      bottomInfo: {},
      bottomNews: [],
      faServiceList:[
        {
            title:'一对一融资辅导',
            intro:'制定融资策略',
            url:require("../../static/images/FAfinancing/yiduiy.png"),
          },{
            title:'梳理商业结构',
            intro:'提供有价值真实信息',
            url:require("../../static/images/FAfinancing/shangyejiegou.png"),
          },{
            title:'约见一流投资机构',
            intro:'打造高效创投桥梁',
            url:require("../../static/images/FAfinancing/yuejian.png"),
          },{
            title:'提供产业资源',
            intro:'深挖产业服务',
            url:require("../../static/images/FAfinancing/changyeziyuan.png"),
          }
      ],
      serviceList:[ //服务列表
          {
            title:'项目筛选',
            intro:'项目沟通、需求评估、合作方案确定、项目需求调研',
            url:require("../../static/images/FAfinancing/shaixuan.png"),
          },{
            title:'商务洽谈',
            intro:'技术开发范围确定、股份和费用确定、合作协议签订',
            url:require("../../static/images/FAfinancing/qiatan.png"),
          },{
            title:'项目价值评估',
            intro:'项目盈利评估、项目风险评定、项目价值评估 \n ',
            url:require("../../static/images/FAfinancing/pinggu.png"),
          },{
            title:'项目监控',
            intro:'研发过程透明监控、研发进度、在线跟踪、产品质量在线跟踪',
            url:require("../../static/images/FAfinancing/jiankong.png"),
          },{
            title:'持续服务',
            intro:'开发版本迭代、技术咨询、技术人员招募、系统运维',
            url:require("../../static/images/FAfinancing/fuwu.png"),
          },
      ],
      titleObj: {
              title: 'FA融资',
              desc: '一匠为企业提供不同维度、不同阶段的股权融资资源，精准对接，提供针对PE\VC基金、产业资本基金、并购重组等的专业FA服务。',
      },
      topStyle:"background-image:url('https://qie-online-sale-qiniu.wsandos.com/uploads/20221201/de3f135c6fc523f206a257f8d962c8d0.png')"
    };
  },
  mounted() {
    this.solutionId = this.$route.params.type;
    this.Pc_Mobile();
    this.getPageData();

			// for(let i = 1; i<25;i++){
			// 	let img = require('../../static/images/FAfinancing/'+i+'.png');
			// 	this.imgList.push(img);
        
			// }
      
      this.getInstitutionsList()
  },
  methods: {
      getInstitutionsList() { //获取合作机构
				this.$http.post("https://eartisanapplets.wsandos.com/api/index/cooperativeagency", null, (res) => {
          this.imgList=res.data
				});
			},
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_FaFinancing");
      } else {
        this.$router.push("/FAfinancing");
      }
    },

    getPageData() {
      this.$http.post("home/index/product", null, (res) => {
        //   console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        this.bottomInfo = res.data.contact[0];
        this.productType = res.data.type;
        this.productAll = res.data.product;
        this.bottomNews = res.data.b_news;
      });
    },
  },
  components: {
    solutionHeader,
    solutionFooter,
  },
};
</script>

<style lang="stylus" scoped>
.fa_content {
  padding: 0 0.24rem;

  h2 {
    text-align: center;
    font-size: 0.38rem;
    font-family: PingFang SC;
    font-weight: 800;
    color: #333333;
    padding: 0.6rem 0 0.1rem;
  }
}

.fa_service_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.fa_service_list {
  width: 48%;
  padding: 0.2rem 0 0.31rem;
  background: #FFFFFF;
  border: 1px solid #E1E6F0;
  margin-top: 0.24rem;
  text-align: center;

  img {
    width: 1.2rem;
    height: 1.2rem;
  }

  p {
    font-size: 0.28rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 0.42rem;
  }
}
.process_box{
  position:relative;
}
.process-line {
  position :fixed;
  margin-top:0.31rem;
  left :0.39rem;
  width: 0.02rem;
  height: 7rem;
  background: #FFC000;
  
}

.process_list {
  display: flex;
  height :1.55rem;
  justify-content: space-between;
  margin: 0 0 0.2rem 0;

  .serial_num {
    display: inline-block;
    width: 0.32rem;
    height: 0.32rem;
    background: #FFC000;
    border-radius: 50%;
    text-align: center;
    font-size: 0.24rem;
    font-family: DIN;
    font-weight: 500;
    color: #333333;
    line-height: 0.32rem;
    margin-top: 0.2rem;
    z-index:2;
  }
}

.peocess_right_box {
  display: flex;
  justify-content: space-between;
  align-items :center;
  background: #FFFFFF;
  border: 1px solid #E1E6F0;
  width: 90%;
  padding: 0.23rem 0.12rem 0.12rem 0.24rem;

  h3 {
    font-size: 0.28rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 0.28rem;
    margin-bottom: 0.18rem;
  }

  p {
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 0.36rem;
  }

  img {
    width: 0.8rem;
    height: 0.8rem;
  }
}
.agency_box{
  display :flex;
  justify-content :space-between;
  flex-wrap :wrap;
  img{
    width :31%;
    height :auto;
    border-bottom :1px solid #f3f3f3;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/FaFinancing.vue